import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { CustomCol, FrameItem } from "../../framesQr/QrFrameItems";
import { setActiveQrTemplate } from "../../../../../redux/slices/qrTemplates";
import { qrResetText } from "../../../../../redux/slices/qrTextSettings";
import { qrResetSettings } from "../../../../../redux/slices/qrSettings";
import { qrResetFrame } from "../../../../../redux/slices/qrFrames";

export default function TemplateNoneBtn() {
  const { activeQrTemplate } = useSelector((state) => ({
    activeQrTemplate: state.qrTemplates.activeQrTemplate,
  }));
  const dispatch = useDispatch();

  const handleResetActiveTemplate = () => {
    dispatch(setActiveQrTemplate(null));
    dispatch(qrResetText());
    dispatch(qrResetSettings());
    dispatch(qrResetFrame());
  };

  return (
    <CustomCol xs={3}>
      <FrameItem
        onClick={handleResetActiveTemplate}
        className={classNames(
          "d-flex justify-content-center align-items-center border rounded-1",
          {
            "border-primary": !activeQrTemplate,
            "border-border-gray": activeQrTemplate,
          }
        )}
        style={{ padding: "20%" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37"
          height="37"
          viewBox="0 0 37 37"
          fill="none"
        >
          <path
            d="M1.03589 1.03564L35.643 35.6428"
            stroke="#727271"
            strokeWidth="1.37097"
          />
          <path
            d="M35.6431 1.03564L1.03592 35.6428"
            stroke="#727271"
            strokeWidth="1.37097"
          />
        </svg>
      </FrameItem>
    </CustomCol>
  );
}
